import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './session.js';

/** Protege la navegación en el cliente. La autorización real la impone la API. */
export function RutaPrivada({ children }: { children: React.ReactNode }): React.JSX.Element {
  const { sesion } = useSession();
  const location = useLocation();

  if (sesion.estado === 'comprobando') {
    return <p role="status">Comprobando sesión…</p>;
  }
  if (sesion.estado === 'anonimo') {
    // `replace` evita que "atrás" devuelva a una página protegida vacía.
    return <Navigate to="/entrar" replace state={{ desde: location.pathname }} />;
  }
  return <>{children}</>;
}
